import { forwardRef } from 'react';
import { MdMenu } from 'react-icons/md';
import Dropdown from 'react-bootstrap/Dropdown';
import Button from 'react-bootstrap/Button';

const NavMenu = ({ user, onSignOut }) => {
  const profile = {
    firstName: user?.name || 'User',
    avatarUrl: user?.picture || '',
  };

  const renderAvatar = () => {
    if (profile.avatarUrl) {
      return (
        <img
          src={profile.avatarUrl}
          alt={profile.firstName || 'User'}
          style={{ width: 36, height: 36, borderRadius: '50%', objectFit: 'cover' }}
        />
      );
    }
    const initial = (profile.firstName || 'U').charAt(0).toUpperCase();
    return (
      <div
        style={{
          width: 36,
          height: 36,
          borderRadius: '50%',
          background: '#7a41ca',
          color: '#fff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: 700,
          letterSpacing: '0.02em',
        }}
      >
        {initial}
      </div>
    );
  };

  const MenuButton = forwardRef(({ onClick }, ref) => (
    <Button
      ref={ref}
      variant='light'
      style={{
        borderRadius: 8,
        width: 44,
        height: 44,
        padding: 0,
        boxShadow: 'none',
      }}
      aria-label='Open menu'
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    >
      <MdMenu size={32} color='var(--bs-gray-600)' />
    </Button>
  ));

  return (
    <Dropdown align='end'>
      <Dropdown.Toggle as={MenuButton} id='nav-menu-toggle' />
      <Dropdown.Menu align='end' className='shadow' style={{ marginTop: 8 }}>
        <div className='d-flex align-items-center gap-3 px-3 py-2'>
          {renderAvatar()}
          <div style={{ fontWeight: 700, fontSize: '1rem' }}>{profile.firstName}</div>
        </div>
        <Dropdown.Divider />
        <Dropdown.Item onClick={onSignOut}>Log out</Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default NavMenu;
